import { Theme } from '../../../../jss';
import { GetSocialClassBase } from './get-social-class-base.styles';

export const GetSocialStyles = (theme: Theme) => {
  const styles = {
    getSocialBase: {
      ...GetSocialClassBase(theme),
    },
  };

  return styles;
};
